import axios from "axios";
import { ConnectionException, createRemoteException, ApplicationException } from "@pjn/core/error";
import delay from "@pjn/utils/delay";
import { addSecurity } from "./security";
export const HttpClient = {
    /**
     * Crea un Cliente HTTP de Axios.
     * En caso de especificar configuracion extra, se agregan los interceptors correspondientes.
     *
     * @param {HttpClientConfig} config Configuracion que se pasa a Axios y agrega `identityProvider` y `delay`.
     * @returns instancia de axios (cliente Ajax)
     */
    create(config) {
        // Se crea el cliente
        const client = axios.create(config);
        // Si se especifico delay, se agrega el interceptor
        if (config.delay)
            client.interceptors.request.use(createDelayInterceptor(config.delay));
        // Si se especifico identity provider, se agrega seguridad
        if (config.identityProvider)
            addSecurity(client, config.identityProvider);
        // Se agrega interceptor de errores para adaptar a nuestras excepciones
        client.interceptors.response.use(response => response, adaptErrors);
        return client;
    }
};
/**
 * Crea un interceptor de request que agrega un delay al proceso
 *
 * @param {number} ms milisegundos de delay a agergar
 * @returns el interceptor
 */
function createDelayInterceptor(ms) {
    return (config) => delay(ms).then(() => config);
}
/**
 * Interceptor de errores que adapta los errores de Axios a las
 * excepciones PJN.
 *
 * @param {*} error response erroneo de axios
 * @returns la nueva excepcion
 */
function adaptErrors(error) {
    let pjnError;
    if (error.response) {
        // El request se envio y el servidor respondio con un status > 299
        pjnError = createRemoteException(error.response.status, error.response.data);
        console.error("ERROR en la respuesta. URL: %s, Status: %d, Headers: %s -> Error generado: %o", error.config.url, error.response.status, error.response.headers, pjnError);
    }
    else if (error.request) {
        // El request se envio pero no se recibio respuesta del server
        // `error.request` es una instancia de XMLHttpRequest en el navegador
        pjnError = new ConnectionException();
        console.error("Error de conexion. URL: %s, XMLHttpRequest: %o -> Error generado: %o", error.config.url, error.request, pjnError);
    }
    else {
        // Un error ocurrio al generar el request
        pjnError = new ApplicationException("Error al generar el request");
        console.log('Error al generar el request "%s". Config: %o -> Error generado: %o', error.message, error.config, pjnError);
    }
    console.log(error.config);
    // Se lanza la excepcion creada en lugar de la original
    return Promise.reject(pjnError);
}
//# sourceMappingURL=HttpClient.js.map